<template>
  <ContentLayout :smallHeader="false" :mediumHeader="true">
    <template #header>
      <h4>{{ title }}</h4>

      <div class="inputs">
        <div class="input">
          <span class="input--text">Procurar por ano (> {{ minYear }}) </span>
          <input class="input--field" :class="{ invalid: !validYear}" type="number" :min="minYear" :max="currentYear" v-model="selectedYear" @keydown="clearName()" />
        </div>

        <div class="input">
          <span class="input--text">Procurar por nome </span>
          <input class="input--field" :class="{ invalid: !validName}" type="text" :value="searchName" v-debounce:500="getNameList" @keydown="selectedYear = null;" />
          <div class="input--list" v-show="!namesHidden">
            <div v-for="(name, key) in names" :key="key" class="input--list-value" @click="updateName(name)">{{ name }}</div>
          </div>
        </div>
      </div>
    </template>

    <div>
      <pdf-viewer v-if="year && year.length === 4" :source="'./pdf/'+ directory +'/year/'+ year +'.pdf'" />
      <pdf-viewer v-if="name" :source="'./pdf/'+ directory +'/name/'+ name +'.pdf'" />
    </div>
  </ContentLayout>
</template>

<script>
import ContentLayout from './ContentLayout';

export default {
  components: {
    ContentLayout
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    minYear: {
      type: Number,
      default: 1900
    },
    directory: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    currentYear: new Date().getFullYear() + 5,
    selectedYear: null,
    selectedName: null,
    searchName: null,
    names: [],
    namesHidden: true,
    validName: true
  }),
  computed: {
    year() {
      if (!this.selectedYear || this.selectedYear.length !== 4 ||
          this.selectedYear > this.currentYear || this.selectedYear <= this.minYear
      ) {
        return null;
      }

      return this.selectedYear;
    },
    validYear() {
      let valid = true;
      const year = parseInt(this.selectedYear);

      if (!year) {
        return valid;
      }

      if (year.length > 4 || year > this.currentYear || year <= this.minYear) {
        valid = false;
      }

      return valid;
    },
    name() {
      if (this.selectedName) {
        return String(this.selectedName).split(' ').join('_');
      }

      return null;
    }
  },
  methods: {
    updateName (val) {
      this.searchName = val;
      this.selectedName = val;
      this.namesHidden = true;
    },
    async getNameList(val) {
      if (!val || !val.trim()) {
        return
      }

      this.selectedName = null;
      this.searchName = val;
      this.namesHidden = false;
      const response = await this.$api.getNameList(this.directory.replace('_', '-'), val);

      // console.log(response.data) // eslint-disable-line

      if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
        this.names = [];
        this.validName = false;
        return
      }

      if (response.data) {
        this.names = response.data;
        this.validName = true;
        return
      }
    },
    clearName () {
      this.selectedName = null;
      this.searchName = null;
      this.namesHidden = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.inputs {
  display: flex;
  justify-content: space-between;
  flex-basis: 100%;

  .input {
    position: relative;

    .input--text {
      font-weight: bold;
      font-size: 1.4rem;
    }

    .input--field {
      padding: 8px;
      border: 2px solid #5280e9;
      border-radius: 2px;
      font-weight: bold;
      font-size: 1.1rem;

      &.invalid {
        border: 2px solid #e95252;
      }
    }

    .input--list {
      position: absolute;
      top: 39px;
      left: 193px;
      width: max-content;
      border: 1px solid #d1d1d1;
      min-width: 196px;
      max-height: 526px;
      background: #fff;
      overflow-y: auto;

      .input--list-value {
        width: 100%;
        padding: 5px;
        margin: 0;
        border-top: 5px;
        border-bottom: 1px solid #d1d1d1;
        cursor: pointer;

        &:last-child {
          border-bottom: 0;
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .inputs {
    .input {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 2px;
      width: 155px;

      .input--text {
        font-weight: bold;
        font-size: 1rem;
      }
      
      .input--list {
        top: 51px;
        left: 0;
        min-width: 155px;
        max-height: 157px;
      }
    }
  }
}
</style>
